<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page  -->
            <h1 class="page__title">{{ title_page }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <!-- Button back -->
            <CButton
                color="primary"
                class=" my-3 button"
                @click=" $router.push({ name: back_page }) "
            >
                <span class="button__icon text-white-50">
                    <CIcon :content="$options.icons.cilArrowThickFromRight"/>
                </span>
                <span class="button__text">
                    {{ $t('back') }}
                </span>
            </CButton>
            <CContainer fluid class="p-0 position-relative h-100">
                <CRow v-for="(step,key) in steps" :key="key">
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <CCardTitle>
                                    {{ getStepTitle(key) }}
                                </CCardTitle>
                            </CCardHeader>
                            <CCardBody>
                                <CContainer fluid>
                                    <CRow>
                                        <CCol 
                                            xl="6" 
                                            md="6"
                                            sm="12" 
                                            class="mb-4"
                                            v-for="(question,key) in step" :key="key" 
                                        >
                                            <CCard class="shadow">
                                                <CCardHeader>
                                                    <h5>{{question.title}}</h5>
                                                </CCardHeader>
                                                <CCardBody>
                                                    <CDataTable
                                                        :addTableClasses="['table--sm']"
                                                        :items="formatFieldsToTableOptions(question.options)"
                                                        :fields="traslateLabels(tables.options.fields)"
                                                        hover
                                                        striped
                                                    >
                                                        <template #percent="{item}">
                                                            <td class="py-2">
                                                                <ChartGauge :value="item.percent.replace('%','')" />
                                                            </td>
                                                        </template>
                                                    </CDataTable>
                                                </CCardBody>
                                            </CCard>
                                        </CCol>
                                    </CRow>
                                </CContainer>
                            </CCardBody>
                        </CCard> 
                    </CCol>
                </CRow>
                <CElementCover v-show="!steps || steps.length == 0" :opacity="1">
                    <div class="no-steps">
                        <div class="text-center mb-2">
                            <CIcon :content="$options.icons.cilChartLine"/>
                        </div>
                        
                        <h2>
                            {{$t('no_steps_recorded')}} 
                        </h2>
                    </div>
                    
                    
                </CElementCover>
            </CContainer>
        </CCardBody>
    </CCard>

</template>

<script>
import TitlePage from "£lement/titlePage";
import ChartGauge from "£lement/ChartGauge";
import pageMixin from "~/mixins/page";

import { cilPlus, cilSettings, cilPencil, cilDataTransferDown,cilMediaPlay, cilWarning, cilChartLine, cilArrowThickFromRight } from '@coreui/icons';

export default {
    name:"FormStatsPage",
    middleware: ["auth","page"],
    mixins: [ pageMixin ],
    components:{
        TitlePage,
        ChartGauge
    },
    icons:{
        cilPlus,
        cilSettings,
        cilPencil,
        cilDataTransferDown,
        cilMediaPlay,
        cilWarning,
        cilChartLine,
        cilArrowThickFromRight
    },
    data(){
        return{
            back_page:"forms",
            steps:null,
            tables:{
                options:{
                    fields: [
                        {
                            key: "response",
                            label:"response",
                            sorter: false,
                            filter: false,
                        },
                        {
                            key: "response_count",
                            label:"responses",
                            sorter: false,
                            filter: false,
                        },
                        {
                            key: "percent",
                            label:"%",
                            sorter: false,
                            filter: false,
                            _style: "width:5%",
                            _classes: "text-center",
                        },
                    ],
                    order:"asc",
                    rows:10,
                    page:1,
                    total_pages:1
                }
            }
        }
    },
    computed:{
        title_page:function(){
            return this.$t("form_stats");
        },
        form_id:function(){
            return this.$route.query.form_id;
        }
    },
    watch:{
    },  
    methods:{

        async updateData() {
            let query = {
                where:{
                    id:this.form_id
                }
            }
            let data = await this.loadData({
                url:"question_option",
                query
            });

            this.steps = data;

            this.$store.dispatch('page/updateLoading', {
                loading: false,
            });
            
        },

        getStepTitle(step){
            return "Step " + step.split("_")[1];
        },
        formatFieldsToTableOptions(options){
            let formatted_options = [];
            for (const key in options) {
                if (Object.hasOwnProperty.call(options, key)) {
                    const item = options[key];
                    formatted_options.push({
                        response:item.title,
                        response_count:item.values.selected,
                        percent:item.values.percent
                    })
                }
            }
            return formatted_options;
        }
    },
    mounted(){
        this.updateData();
    }
}
</script>

<style scoped lang="scss">
    .no-steps{
        font-size: 1em;
        & .c-icon{
            width: 3rem;
            height: auto;
        }
    }
</style>